import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import { postResendPasswordResetEmail } from '../../../../backend-api';
import { Button } from '../../../../components';
import { t } from '../../../../i18n';
import { logError } from '../../../../utilities/log';
import './styles.scss';

const SendStatus = {
  CONFIRM_SENDING: 'CONFIRM_SENDING',
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};

const SendNewLink = ({ token }) => {
  const [sendStatus, setSendStatus] = useState(SendStatus.CONFIRM_SENDING);

  const handleSendNewLink = async () => {
    setSendStatus(SendStatus.LOADING);
    try {
      await postResendPasswordResetEmail(token);
      setSendStatus(SendStatus.SUCCESS);
    } catch (e) {
      logError('SendNewLink', "Couldn't send new password reset link", e);
      setSendStatus(SendStatus.ERROR);
    }
  };

  if (sendStatus === SendStatus.SUCCESS) {
    return (
      <div className="reset-password__send-new-link">
        <Alert variant="success">{t('DIGITAL_COURSES.RESET_PASSWORD.LINK_RESENT')}</Alert>
      </div>
    );
  }

  return (
    <div className="reset-password__send-new-link">
      <Alert variant="warning">{t('DIGITAL_COURSES.RESET_PASSWORD.LINK_EXPIRED')}</Alert>
      <Button
        text={t('DIGITAL_COURSES.RESET_PASSWORD.SEND_NEW_LINK')}
        onClick={handleSendNewLink}
        disabled={sendStatus === SendStatus.LOADING}
        className="reset-password__send-new-link-button"
      />
      {sendStatus === SendStatus.ERROR && (
        <strong className="reset-password__send-new-link-error">{t('SERVER_ERROR')}</strong>
      )}
    </div>
  );
};

export default SendNewLink;
